import MdToolbar from "./MdToolbar"

const MdToolbarPlugin = {
  install(app) {
    app.component(MdToolbar.name, MdToolbar)
  },
}

export default MdToolbarPlugin
